module.exports = __webpack_public_path__ + "img/half-circle-3.cfa5dbd3.svg";